import _extends from "@babel/runtime/helpers/extends";
import { Box, SectionHelper, TextButton } from '@wix/design-system';
import React from 'react';
import { useCycleAvailability } from '../../hooks/useCycleAvailability';
import { useMonthlyCycleSavings } from '../../hooks/useMonthlyCycleSavings';
import { TWO_YEAR_CYCLE_ID, TWO_YEAR_PURCHASE_CYCLE, YEARLY_CYCLE_ID } from '../../utils/consts';
import { useCurrentModule } from '../ModuleProvider';
import s from './CycleSelectorDisabledFeatures.scss';
import { DARK_UNDERLINED_LINK_PROPS } from './monthlyNoteLinkProps';
import { useSelectCycleFromMonthlyNote } from './useSelectCycleFromMonthlyNote';
export const MonthlyCycleUpsellHelper = _ref => {
  let {
    productId,
    mobile
  } = _ref;
  const module = useCurrentModule();
  const {
    t,
    Trans
  } = module.internals.useTranslations();
  const {
    yearlySavings,
    twoYearSavings,
    hasTwoYearCycle,
    hasSavingsAmounts,
    isLoading: areSavingsLoading
  } = useMonthlyCycleSavings(productId);
  const selectCycle = useSelectCycleFromMonthlyNote();
  const {
    isCycleAvailable: isTwoYearCycleAvailable,
    isLoading: isTwoYearAvailabilityLoading
  } = useCycleAvailability(productId, TWO_YEAR_PURCHASE_CYCLE);
  const showsTwoYearAction = hasTwoYearCycle && isTwoYearCycleAvailable;
  const actionProps = showsTwoYearAction ? {
    actionText: t('cycle_entry.monthly_disclaimer.upsell_cta'),
    onAction: selectCycle(TWO_YEAR_CYCLE_ID, 'select-2year-cycle')
  } : {};
  if (areSavingsLoading || isTwoYearAvailabilityLoading) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    className: s.upsellHelper,
    width: "100%",
    marginTop: mobile ? '6px' : '12px',
    marginBottom: mobile ? '6px' : undefined
  }, /*#__PURE__*/React.createElement(SectionHelper, _extends({
    dataHook: "monthly-cycle-upsell-helper",
    skin: "premium",
    fullWidth: true,
    showPrefixIcon: false
  }, actionProps), hasSavingsAmounts ? /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "cycle_entry.monthly_disclaimer.upsell",
    values: {
      yearlySavings,
      twoYearSavings
    },
    components: {
      1: /*#__PURE__*/React.createElement(TextButton, _extends({
        size: "small"
      }, DARK_UNDERLINED_LINK_PROPS, {
        onClick: selectCycle(YEARLY_CYCLE_ID, 'select-1year-cycle')
      }))
    }
  }) : /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "cycle_entry.monthly_disclaimer.upsell_no_amounts"
  })));
};
//# sourceMappingURL=MonthlyCycleUpsellHelper.js.map